import * as types from 'store/modules/hress1e/mutation-types'
import hress1e from 'api/hress1e'
import swal from 'sweetalert'
import hress1eLabels from 'assets/labels/hress1e'
import { hress1eColumns } from 'assets/columns/hress1e'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hress1eLabels,
    columns: hress1eColumns(),
    index: {
      total: 0,
      rows: []
    },
    indexSelected: {},
    detail: {
      table1: {
        total: 0,
        rows: []
      },
      table2: {
        total: 0,
        rows: []
      }
    },
    dropdowns: {
      status: {
        en: {},
        th: {}
      }
    }
  },
  getters: {
    [types.GET_HRESS1E_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRESS1E_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRESS1E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRESS1E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRESS1E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRESS1E_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRESS1E_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRESS1E_DROPDOWNS] (state) {
      return state.dropdowns
    }
  },
  mutations: {
    [types.SET_HRESS1E_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRESS1E_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRESS1E_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detail1Columns = configLabel.replaceLabelToColumns(state.columns[keyLang].detail1Columns, labels[keyLang])
        state.columns[keyLang].detail2Columns = configLabel.replaceLabelToColumns(state.columns[keyLang].detail2Columns, labels[keyLang])
      }
    },
    [types.SET_HRESS1E_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRESS1E_INDEX] (state, index) {
      state.index = index
    },
    [types.SET_HRESS1E_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRESS1E_DETAIL] (state, detail) {
      state.detail = detail
    },
    [types.SET_HRESS1E_DROPDOWNS] (state, dropdowns) {
      state.dropdowns = dropdowns
    }
  },
  actions: {
    [types.TOGGLE_HRESS1E_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRESS1E_INDEX_DISP, indexDisp)
      commit(types.SET_HRESS1E_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRESS1E_COLUMNS_LABELS] ({ commit }) {
      hress1e.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS1E_COLUMNS, data.labels)
          commit(types.SET_HRESS1E_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRESS1E_INDEX] ({ commit }, searchParams) {
      hress1e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS1E_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRESS1E_INDEX, objData)
        })
    },
    [types.RECEIVED_HRESS1E_DETAIL] ({ commit }, searchParams) {
      hress1e.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS1E_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRESS1E_DROPDOWNS] ({ commit }) {
      hress1e.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS1E_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRESS1E_DETAIL2_SAVE] ({ commit, dispatch }, { searchIndex, indexSelected, dataRowsHasFlg }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hress1e.postDetail2Save({ indexSelected, dataRowsHasFlg })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRESS1E_INDEX, searchIndex)
              let searchParams = {
                p_dteyreap: indexSelected.dteyreap,
                p_numtime: indexSelected.numtime,
                p_kpino: indexSelected.kpino
              }
              dispatch(types.RECEIVED_HRESS1E_DETAIL, searchParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hress1e/index.js